module.exports = __webpack_public_path__ + "img/banking-open-api-hero.7b6c9725.svg";